<template>
  <v-container
    id="banner"
    tag="section"
  >
    <v-row>
      <v-col>
        <v-card
          elevation="0"
          dark
        >
          <v-img
            :src="require('@/assets/IMG-20191116-WA0013.jpg')"
            class="grey lighten-2 align-center"
            height="500"
            width="100%"
          >
            <v-card-title class="align-end">
              <div class="text-h3 font-weight-bold pl-md-15 text-uppercase">
                Desmond Zhang
              </div>
            </v-card-title>

            <v-card-subtitle>
              <div class="white--text text-h5 pl-md-15 font-weight-light">
                张俊杰
              </div>
            </v-card-subtitle>

            <v-card-text>
              <div class="text-h5 pl-md-16 font-weight-light mb-4">
                Ph.D Candidate | Web Developer | Film Addict | Gamer
              </div>
            </v-card-text>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeBanner',
  }
</script>
